import {
  Component,
  HostBinding,
  AfterViewInit,
  inject,
  Inject,
} from '@angular/core';
import { ThemeToggleComponent } from '../../partials/theme-toggle/theme-toggle.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { RouterOutlet } from '@angular/router';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MetronicInitService } from '../../core/services/metronic-init.service';
import {
  SwFormBuilderModule,
  FormElementMenuComponent,
  MainCanvasComponent,
  FieldSettingsComponent,
} from 'sw-form-builder';
import { FormStateService } from 'sw-form-core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-builder',
  imports: [
    RouterOutlet,
    CommonModule,
    DragDropModule,
    ThemeToggleComponent,
    HeaderComponent,
    FooterComponent,
    SwFormBuilderModule,
    FormElementMenuComponent,
    MainCanvasComponent,
    FieldSettingsComponent,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
  ],
  providers: [FormStateService],
  templateUrl: './builder.component.html',
  styleUrl: './builder.component.scss',
})
export class BuilderComponent implements AfterViewInit {
  @HostBinding('class') class = 'flex grow';
  private metronicInitService = inject(MetronicInitService);

  formService = Inject(FormStateService);
  formList: any[] = new Array();
  formTitle: string = '';
  selected: string = '';
  formId: number = 0;

  ngAfterViewInit(): void {
    this.metronicInitService.init();
  }

  exportForm() {
    const formJson = this.formService.exportForm();
    const dataStr =
      'data:text/json;charset=utf-8,' +
      encodeURIComponent(JSON.stringify(formJson, null, 2));
    const downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute('href', dataStr);
    downloadAnchorNode.setAttribute('download', 'form.json');
    document.body.appendChild(downloadAnchorNode);
  }
  saveFormToBackend() {}
}
